import tinycolor from 'tinycolor2';
import { Colors } from '@brg/ui';
import { DefaultTheme } from 'styled-components';
import { ApplicationTheme } from "../themes";
import { AppTester } from 'supporting';

enum BRS_VALUES {
  white = 255,
  lessWhite = 215,
  normal = 110,
  dark = 60
}

export const createThemeByColor = (color: string, source: DefaultTheme, isEdit?: boolean) => {
  const visibleTextColor = tinycolor.mostReadable(color, [Colors.geoWhite100, Colors.galBlack100]).toHexString();
  const isDarkText = visibleTextColor === Colors.galBlack100;
  const isCGRave = AppTester.isCGRAVE();
  const isGeo = AppTester.isGeograffee();
  const isGeoDafes = AppTester.isGeoDafes();
  const isGameDeziiign = AppTester.isGameDeziiign();

  const getCalcTheme = () => {
    const brs = tinycolor(color).getBrightness();

    if (!isEdit) {
      return isDarkText ? ApplicationTheme.white : ApplicationTheme.grey
    }

    if (isGeo && !isGeoDafes) return ApplicationTheme.grey;
    else if (brs >= BRS_VALUES.lessWhite) return ApplicationTheme.white;
    else if (brs >= BRS_VALUES.normal) return ApplicationTheme.additionalWhite_1;
    else if (brs > BRS_VALUES.dark) return ApplicationTheme.additionalWhite_2;
    return ApplicationTheme.black;
  }

  const newTheme = {
    ...(getCalcTheme()),
    navigationBar: {
      ...ApplicationTheme.white.navigationBar,
    },
    isDarkText,
  }

  const gameDeziiignTheme = {
    ...newTheme,
    navigationBar: {...source.navigationBar},
    isDarkText
  }

  if (source.app.backgroundColor === '#000000' && !isCGRave) {
    return {
      theme: ApplicationTheme.black,
      isDarkText: false,
    };
  }

  return {
    theme: isGameDeziiign ? gameDeziiignTheme : newTheme,
    isDarkText,
  };
};
import tinycolor from 'tinycolor2';
import { Colors } from '@brg/ui';
import { DefaultTheme } from 'styled-components';
import { ApplicationTheme } from "../themes";
import { AppTester } from 'supporting';

enum BRS_VALUES {
  white = 255,
  lessWhite = 215,
  normal = 110,
  dark = 60
}

export const createThemeByColor = (color: string, source: DefaultTheme, isEdit?: boolean) => {
  const visibleTextColor = tinycolor.mostReadable(color, [Colors.geoWhite100, Colors.galBlack100]).toHexString();
  const isDarkText = visibleTextColor === Colors.galBlack100;
  const isCGRave = AppTester.isCGRAVE();
  const isGeo = AppTester.isGeograffee();
  const isGeoDafes = AppTester.isGeoDafes();
  const isGameDeziiign = AppTester.isGameDeziiign();

  const getCalcTheme = () => {
    const brs = tinycolor(color).getBrightness();

    if (!isEdit) {
      return isDarkText ? ApplicationTheme.white : ApplicationTheme.grey
    }

    if (isGeo && !isGeoDafes) return ApplicationTheme.grey;
    else if (brs >= BRS_VALUES.lessWhite) return ApplicationTheme.white;
    else if (brs >= BRS_VALUES.normal) return ApplicationTheme.additionalWhite_1;
    else if (brs > BRS_VALUES.dark) return ApplicationTheme.additionalWhite_2;
    return ApplicationTheme.black;
  }

  const newTheme = {
    ...(getCalcTheme()),
    navigationBar: {
      ...ApplicationTheme.white.navigationBar,
    },
    isDarkText,
  }

  const gameDeziiignTheme = {
    ...newTheme,
    navigationBar: {...source.navigationBar},
    isDarkText
  }

  if (source.app.backgroundColor === '#000000' && !isCGRave) {
    return {
      theme: ApplicationTheme.black,
      isDarkText: false,
    };
  }

  return {
    theme: isGameDeziiign ? gameDeziiignTheme : newTheme,
    isDarkText,
  };
};
